import React from "react";
import { NavLink } from "react-router-dom";
import LocationForm from "../AllLocationComponents/LocationPageForm";
import { BsArrowUpRightCircle } from "react-icons/bs";

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import { BiPlus } from "react-icons/bi";
import { AiOutlineMinus } from "react-icons/ai";
import { Link } from "react-router-dom";
// let ApprochIconImgs = [
//   "https://ezmarketingtech.s3.amazonaws.com/img/colorado_icon.png",
//   "https://ezmarketingtech.s3.amazonaws.com/img/taxas_rang_icon.png",
//   "https://ezmarketingtech.s3.amazonaws.com/img/colorado_icon3.png",
//   "https://ezmarketingtech.s3.amazonaws.com/img/taxas_target_icon.png",
//   "https://ezmarketingtech.s3.amazonaws.com/img/talk_rio_img.png",
// ];


const NewYorkCity = () => {
  return (
    <>
      <section className="banner_section location_banner">
        <div className="container">
          <h1 className="all_main_heading mb-3">Digital Marketing Services For NYC Brands</h1>

          <div className="location_banner_wrap">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-5">
                <div className="location_banner_text">
                  <h2>Captivating NYC Digital<br /> Marketing Solutions Tailored<br /> For Your Business!</h2>
                  <p>
                    Discover the power of bespoke digital marketing solutions with <a href="/">EZ Marketing Agency</a>, your New York City specialist. At the heart of the world's most dynamic market, we understand the unique challenges and opportunities your business faces in NYC. Our team, equipped with cutting-edge tools and insights, crafts personalized strategies that resonate with your specific audience. From SEO and social media marketing to innovative content marketing and analytics, we ensure every aspect of your digital presence is fine-tuned for maximum impact. Partner with EZ Marketing Agency and experience a tailored approach to digital marketing that not only meets but exceeds your business goals in the bustling landscape of New York City.
                  </p>
                  <NavLink className="class_us" to="/us/contact-us">
                    Contact us
                  </NavLink>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-7">
                <div className="location_proposal_wrap">
                  <h3>GET MY FREE PROPOSAL</h3>
                  <LocationForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="seo_approch_sec seo_approch_sec2 nyc_approch">
        <div className="container">
          <h2>
            Why Choose Us?
          </h2>
          <p className="all_main_discription">EZ Marketing Agency offers premium digital marketing services tailored to meet diverse needs and ensure a robust online presence. Our strategies are carefully designed to elevate your brand, utilizing innovative methods and continuous support. With EZ Marketing Agency, you can expect to gain a competitive edge in the digital arena through smart tactics and dedicated guidance, paving the way for your brand's success in NYC.</p>

          <div className="row j-center mt-5 mb-5">
            <div className="col-12 col-sm-12 col-md-4 col-lg-4 h-100">
              <div className="approch_improve_text">
                <img src={require('../../ImagesComponents/bannerImg/customize_img.png')} alt="img" />
                <h3>Customized Strategies</h3>
                <p>
                  We firmly believe that there's no one-size-fits-all solution in the world of digital marketing. Our team is driven by a commitment to innovation and creativity, allowing us to craft personalized digital marketing strategies that are perfectly aligned with your unique business needs. Whether it's creating captivating social media campaigns or implementing cutting-edge SEO techniques, we're here to ensure that your brand not only survives but thrives in the digital world.
                </p>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-4 col-lg-4 h-100 b-left">
              <div className="approch_improve_text">
                <img src={require('../../ImagesComponents/bannerImg/customize_img2.png')} alt="img" />
                <h3>
                  Local Expertise, Global Excellence
                </h3>
                <p>
                  Our extensive knowledge of the New York market, complemented by our grasp of global digital marketing and SEO trends, equips us to design marketing strategies that authentically connect with the local scene while making a profound impression worldwide. We've got our ear to the ground in the “Big Apple” and tailor your campaigns to sync with the city's dynamic pulse.
                </p>
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-4 col-mb-4 h-100 b-left ">
              <div className="approch_improve_text">
                <img src={require('../../ImagesComponents/bannerImg/customize_img3.png')} alt="img" />
                <h3>Data-Driven Insights</h3>
                <p>
                  When it comes to SEO, PPC, or social media, we bring together the power of data-driven decision-making and the artistry of creative marketing. This means we leverage analytics and metrics to shape our strategies for optimal results, while infusing the dynamic and unconventional essence of NYC into our creative process. As a result, your campaigns are not only effective but also embody the lively spirit of New York, making them truly engaging.
                </p>
              </div>
            </div>
          </div>
          <div className="strategies_wrap superior_strategies_wrap">
            <h3>Tailored Approaches For Superior Digital Results</h3>
            <p>At <a href="/">EZ Marketing Agency</a>, our expertise lies in elevating your brand to a prominent position on digital platforms, not just joining the online competition, but steering it. Recognizing the importance of online presence in a world where customers thoroughly research and compare products, we emphasize the significance of ranking high in Google search results. Our proficiency in this field has been proven through the success of numerous businesses across the country, boosting their online visibility and subsequently broadening their clientele. The following are some of the industries we serve:</p>

          </div>
          <div className="navada_social text-center">
            <ul className="navada_Social_list lower_border">
              <li>
                <div className="legal_wrapper">
                  <img src={require('../../ImagesComponents/bannerImg/legal_img1.png')} alt="img" />
                  <h4>Legal Services</h4>
                </div>

              </li>
              <li>
                <div className="legal_wrapper">
                  <img src={require('../../ImagesComponents/bannerImg/legal_img2.png')} alt="img" />
                  <h4>Events and Conferences</h4>
                </div>

              </li>
              <li>
                <div className="legal_wrapper">
                  <img src={require('../../ImagesComponents/bannerImg/legal_img3.png')} alt="img" />
                  <h4> Healthcare & Wellness</h4>
                </div>

              </li>
              <li>
                <div className="legal_wrapper">
                  <img src={require('../../ImagesComponents/bannerImg/legal_img4.png')} alt="img" />
                  <h4> Food & Beverages</h4>
                </div>

              </li>
            </ul>

            <ul className="navada_Social_list">
              <li>
                <div className="legal_wrapper">
                  <img src={require('../../ImagesComponents/bannerImg/legal_img5.png')} alt="img" />
                  <h4>Retail & E-Commerce</h4>
                </div>

              </li>
              <li>
                <div className="legal_wrapper">
                  <img src={require('../../ImagesComponents/bannerImg/legal_img6.png')} alt="img" />
                  <h4> Hospitality and Tourism</h4>
                </div>

              </li>
              <li>
                <div className="legal_wrapper">
                  <img src={require('../../ImagesComponents/bannerImg/legal_img7.png')} alt="img" />
                  <h4>Entertainment & Nightlife</h4>
                </div>
              </li>
              <li>
                <div className="legal_wrapper">
                  <img src={require('../../ImagesComponents/bannerImg/legal_img8.png')} alt="img" />
                  <h4>Real Estate and many more!</h4>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <section className="strategies_wrap_sec">
        <div className="container">
          <div className="strategies_wrap strategies_wrap_Sneak">
            <h3>A Sneak Peek Into Our Services</h3>
            <p>Our trailblazing digital marketing and SEO specialists are wholly devoted to achieving quantifiable outcomes, ensuring your sector doesn't just follow but paves the way in the digital landscape. Enhance your business with meticulously crafted solutions built for success.</p>

          </div>
          <div className="navada_social navada_social_legal text-center row">
            <div className="col-12 col-sm-12 col-md-12 col-lg-3">
              <strong className="sneak-heading">Here is a look at<br /> the services we offer: </strong>
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-9">
              <div className="row">
                <div className="col-12 col-sm-6 col-md-4 col-lg-4">
                  <Link
                    to="us/amazon-seo-services"

                    rel="noreferrer"
                  >
                    <span className="item_arrow"><BsArrowUpRightCircle className="arrow_icon"/></span>
                    <span>Amazon SEO</span>
                  </Link>
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-lg-4">
                  <Link
                    to="us/ppc-marketing"

                    rel="noreferrer"
                  >
                    <span className="item_arrow"><BsArrowUpRightCircle className="arrow_icon"/></span>
                    <span>Pay-Per-Click/Adwords</span>
                  </Link>
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-lg-4">
                  <Link
                    to="us/content-marketing-services"
                    rel="noreferrer"

                  >
                    <span className="item_arrow"><BsArrowUpRightCircle className="arrow_icon"/></span>
                    <span>Content Marketing</span>
                  </Link>
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-lg-4">
                  <Link
                    to="us/social-media-marketing"
                    rel="noreferrer"

                  >
                   <span className="item_arrow"><BsArrowUpRightCircle className="arrow_icon"/></span>
                    <span>Social Media Marketing</span>
                  </Link>
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-lg-4">
                  <Link
                    to="us/reputation-management-services"
                    rel="noreferrer"

                  >
                    <span className="item_arrow"><BsArrowUpRightCircle className="arrow_icon"/></span>
                    <span>Reputation Management</span>
                  </Link>
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-lg-4">
                  <Link
                    to="/us/ecommerce-seo-services"
                    rel="noreferrer"

                  >
                 <span className="item_arrow"><BsArrowUpRightCircle className="arrow_icon"/></span>
                    <span>E-Commerce SEO</span>
                  </Link>
                </div>
                <div className="col-12 col-sm-6 col-md-4 col-lg-4">
                  <Link
                    to="/us/seo-services"
                    rel="noreferrer"

                  >
                   <span className="item_arrow"><BsArrowUpRightCircle className="arrow_icon"/></span>
                    <span>Search Engine Optimization</span>
                  </Link>
                </div>
              </div>
            </div>

          </div>
          <p>Take a glimpse into our services and embark on a journey to elevate your business. <a href="/contact-us">Contact us</a> today and discover the path to success –<br /> explore our offerings today!</p>
        </div>
      </section>
      <section className="seo_nevada_sec">
        <div className="container">
          <div className="row">
            <div className="strategies_wrap_nyc">
              <h3>NYC's Own – Delivering Customer Service<br /> With Heart And Dedication</h3>
              <p>
                In a city that never sleeps, standing out in the digital landscape demands innovative strategies and a personalized touch. That's why we create tailored digital marketing campaigns that resonate with your unique online brand reputation and objectives. Our approach blends creativity with data-driven tactics, ensuring your business embodies the dynamic spirit of the “Big Apple” while maximizing its online potential.
              </p>
              <p>What truly distinguishes us is our unwavering commitment to sustainable growth and ethical practices. We steer clear of quick fixes and black-hat techniques that might promise short-term gains but jeopardize your long-term online reputation. Instead, we prioritize building a strong, authentic online presence that aligns with your brand's core values.</p>
              <p>With <a href="/">EZ Marketing Agency</a>’s team of digital marketing experts, you're not just getting a service provider – you're gaining a dedicated partner invested in your success. We're here to guide you through every stage of your digital journey, ensuring that your business not only thrives in the competitive landscape of the "City That Never Sleeps" but also leaves a lasting imprint in the digital world.</p>

            </div>
          </div>
        </div>
      </section>

      <section className="mb-5 seo_faq_section philadelphia_faq_section nyc-faq">
        <div className="container">
          <h3>FAQs</h3>
          <div className="seo_tabs_wrapper">
            <Accordion>
              <AccordionItem class="accordion__item active">
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <h3>
                      Can I request a social media consultation to discuss my NYC business's digital marketing needs?
                      <BiPlus className=" auto_show" />
                      <AiOutlineMinus className=" after_show" />
                    </h3>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>Absolutely! We encourage you to reach out to us through our website to schedule a consultation. During the consultation, we'll discuss your goals, budget, and current marketing efforts. This will help us create a customized digital marketing solution tailored to your NYC business's unique needs and objectives.</p>
                </AccordionItemPanel>
              </AccordionItem>

              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <h3>
                      I run a boutique fashion store in Brooklyn. Can EZ Marketing Agency help me target a local audience and increase foot traffic to my store?
                      <BiPlus className=" auto_show" />
                      <AiOutlineMinus className=" after_show" />
                    </h3>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>Absolutely! EZ Marketing Agency experts specialize in local SEO and geo-targeting strategies that can help boost foot traffic to your Brooklyn boutique. We'll tailor our digital marketing solutions to reach your specific audience and drive more local customers to your store.</p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <h3>
                      My NYC-based tech startup is on a tight budget. Are there cost-effective digital marketing options available with EZ Marketing Agency?
                      <BiPlus className=" auto_show" />
                      <AiOutlineMinus className=" after_show" />
                    </h3>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>Yes, we understand the importance of budget-conscious marketing. EZ Marketing Agency offers cost-effective digital marketing solutions, such as targeted online advertising campaigns and content optimization, to help your tech startup gain visibility and attract investors or customers without breaking the bank.</p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <h3>
                      I have a unique niche business in NYC. How can EZ Marketing Agency create a tailored marketing strategy for my specific industry?
                      <BiPlus className=" auto_show" />
                      <AiOutlineMinus className=" after_show" />
                    </h3>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>EZ Marketing Agency specializes in creating customized digital marketing strategies. We'll conduct in-depth market research to understand your niche industry and your competitors. This allows us to develop a tailored marketing plan that addresses your unique challenges and opportunities.</p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    <h3>
                      I'm not sure which digital marketing channels are right for my NYC business. Can EZ Marketing Agency provide guidance on the most effective platforms to invest in?
                      <BiPlus className=" auto_show" />
                      <AiOutlineMinus className=" after_show" />
                    </h3>
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>Certainly! EZ Marketing Agency offers strategic consultations to help businesses like yours identify the most suitable digital marketing channels. We'll assess your goals, target audience, and industry trends to recommend the platforms that will yield the best results for your specific needs. <a href="/contact-us">Contact us now</a> for more information!</p>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </section>

    </>
  );
};

export default NewYorkCity;
